<mat-card appearance="outlined" class="v-host-card">
  @if (status() !== 'DEACTIVATED') {
    <div class="header row">
      <div>
        <h2>Origin Vhost</h2>
        @if (originVhostId(); as id) {
          <span>ID {{ id }}</span>
        }
      </div>
      <fa-icon
        class="icon"
        [icon]="['fas', 'circle-info']"
        size="lg"
        matTooltip="Origin Vhost (Virtual Host) is the website’s server profile that stores configuration for how the site runs on the origin server, such as PHP settings, SSL configuration, domains, redirects, and other server rules."
      ></fa-icon>
      <div class="space row">
        <app-status-label [status]="status()"></app-status-label>
        <button matRipple class="menu button" [matMenuTriggerFor]="menu">
          <fa-icon [icon]="['fas', 'ellipsis-vertical']" size="lg"></fa-icon>
        </button>

        <mat-menu #menu="matMenu">
          <button mat-menu-item class="red" (click)="deleteVhost()">
            <fa-icon [icon]="['fas', 'trash']" size="sm"></fa-icon>
            <span>Delete CDN Vhost</span>
          </button>
        </mat-menu>
      </div>
    </div>

    @if (aliases$ | async; as aliases) {
      <div class="elevated row">
        <div class="column">
          <h5>Aliases</h5>
          <span>{{ aliases }}</span>
        </div>
        <button matButton="outlined" (click)="editAliases()">
          <fa-icon [icon]="['fas', 'pen']" size="lg"></fa-icon>
          Edit Aliases
        </button>
      </div>
    }

    <div class="elevated row">
      <div class="column">
        <h5>Wildcard DNS</h5>
        <span
          >Creates A record to point all subdomains to the same server IP. Commonly used in
          multisites with subdomains.</span
        >
      </div>
      <mat-slide-toggle
        [checked]="wildcardEnabled()"
        (change)="onWildcardToggleChange($event)"
        [disabled]="loadingWildcard()"
      ></mat-slide-toggle>
    </div>
  } @else {
    <h2>Origin Vhost</h2>
    <span>This website does not have Origin Vhost in VMAX yet.</span>
    <button matButton="filled" id="add-cdn" [disabled]="loadingVhost()" (click)="createVhost()">
      <fa-icon [icon]="['fas', 'plus']" size="lg"></fa-icon>
      Add Origin Vhost
    </button>
  }
</mat-card>
